import Vue from 'vue'
import iView from 'iview' // 引入iview依赖
import 'iview/dist/styles/iview.css' // 引入iview css样式
import App from './App'
import router from './router'
import axiosConfig from './service/config'
Vue.config.productionTip = false
import {Spin} from 'iview';
Vue.prototype.$Spin = Spin;
Vue.use(iView) //使用iview组件 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js